var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Icons","transform":"translate(-267.000000, -971.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"check","transform":"translate(267.000000, 971.000000)"},React.createElement("g",{"id":"Livello_1"},React.createElement("polygon",{"id":"Shape","points":"6.36363636 13.2618182 0 6.89818182 1.79454545 5.10363636 6.36363636 9.66 16.0236364 0 17.8181818 1.80727273"})))))]);
}

Check.defaultProps = {"width":"18px","height":"14px","viewBox":"0 0 18 14","version":"1.1"};

module.exports = Check;

Check.default = Check;
